import React from 'react'
import { Skeleton } from '@/components/ui/skeleton'

const FolderAccessDialogSkeleton: React.FC = () => (
  <div className="space-y-2 p-1">
    {Array.from({ length: 8 }).map((_, i) => (
      <div key={i} className="flex items-center gap-2">
        <Skeleton className="h-4 w-4" />
        <Skeleton className="h-4 flex-1" />
        <Skeleton className="h-7 w-28" />
      </div>
    ))}
  </div>
)

export default FolderAccessDialogSkeleton
